import React from "react";

const Footer = () => {
  return (
    <footer className="mt-10 bg-[#1c2143] px-4 py-5 sm:px-6">
      <div className="mx-auto max-w-[1250px] text-center">
        <p className="text-sm text-white">
          © {new Date().getFullYear()} Mauricio Fernández Licciardi. Todos los
          derechos reservados.
        </p>

        <p className="mt-2 text-sm text-white/70">
          Página desarrollada con React y Tailwind CSS.
        </p>
      </div>
    </footer>
  );
};

export default Footer;